// src/components/auth/OAuth2RedirectHandler.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const OAuth2RedirectHandler = () => {
    const { handleOAuth2Redirect } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const success = handleOAuth2Redirect();
        if (success === true) {
            navigate('/app'); // Przekieruj do głównej aplikacji po sukcesie
        } else if (success === false) {
            navigate('/login', { state: { error: 'Logowanie przez OAuth2 nie powiodło się.' }}); // Przekieruj na logowanie z błędem
        } else {
            // Jeśli handleOAuth2Redirect zwróci null (brak tokena/błędu w URL),
            // to znaczy, że użytkownik mógł tu trafić przypadkowo.
            // Można go przekierować na stronę główną lub logowania.
            navigate('/');
        }
    }, [handleOAuth2Redirect, navigate]);

    // Możesz wyświetlić prosty komunikat ładowania
    return <div>Przetwarzanie logowania...</div>;
};

export default OAuth2RedirectHandler;